<ng-container *transloco="let t">
  <app-admin-card-with-title
    [cardTitle]="t('race.pricing.registrationFees')" [showToggleButton]="true"
    [isContentVisible]="!raceCommericalItemsCollapsed" [removeTopMargin]="true">
    <div slot="trailingWidget">
      <div class="pe-4">
        <app-rounded-button [label]="t('race.pricing.addRegistrationFee')" (onClick)="openEditModal()"
                            [isDisabled]="disableEditing" [btnClass]="'rounded-button--solid'"><i
          class="bi bi-plus-circle pe-2"></i></app-rounded-button>
      </div>
    </div>
    @if (raceCommercialItems.length > 0) {
      <div class="table-responsive">
        <table class="table dark-header table-last-row-no-border" infinite-scroll [infiniteScrollDistance]="4">
          <thead>
          <tr>
            <th class="name-column-width">{{ t("race.pricing.raceCommercialItem.name") }}</th>
            <th>{{ t("race.pricing.raceCommercialItem.description") }}</th>
            <th class="price-column-width">{{ t("race.pricing.price") }}</th>
            <th>{{ t("race.pricing.raceCommercialItem.type") }}</th>
            <th class="more-column-width"></th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
            @for (raceCommercialItem of raceCommercialItems;track raceCommercialItem) {
              <tr>
                <td class="center-align fw-semibold">
                  <app-language-output [hrLabel]="raceCommercialItem.name"
                                       [enLabel]="raceCommercialItem.nameEng" [itLabel]="raceCommercialItem.nameIta"
                                       [siLabel]="raceCommercialItem.nameSlo"
                                       [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
                </td>
                <td class="center-align">{{ raceCommercialItem.internalDescription }}</td>
                <td class="center-align">
                  @if (raceCommercialItem.priceConstantByPeriod) {
                    <span>
                      {{ raceCommercialItem.price | myCurrency:getCurrencyLabel() }}
                    </span>
                  }
                  @for (period of raceCommercialItem.periods;let idx=$index;track period) {
                    <span>
                      {{
                        (period.price | myCurrency:getCurrencyLabel()) + (idx < (raceCommercialItem.periods!.length - 1)
                          ? ", " : "")
                      }}
                    </span><br/>
                  }
                </td>

                <td class="center-align">
                  <div class="w-100-px">
                    <div class="status-badge"
                         [ngClass]="{'denied': raceCommercialItem.registrationFeeTypeId === 1 , 'on-hold': raceCommercialItem.registrationFeeTypeId === 2}">
                      <span class="fw-bold">
                        {{
                          t("race.pricing.raceCommercialItem.type." + raceCommercialItem.registrationFeeTypeId) |
                            uppercase
                        }}
                      </span>
                    </div>
                  </div>
                </td>

                <td class="text-end center-align">
                  @if (!disableEditing) {
                    <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                      <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                        <li ngbDropdownItem (click)="openEditModal(raceCommercialItem)" class="cursor-pointer">{{
                            t("app.common.edit")
                          }}
                        </li>
                        <li ngbDropdownItem (click)="onDeleteRaceCommercialItem(raceCommercialItem)"
                            class="cursor-pointer">{{
                            t("app.common.delete")
                          }}
                        </li>
                      </ul>
                    </div>
                  }
                </td>
              </tr>
            }
        </table>
      </div>
    } @else {
      <div class="my-3">
        <app-empty-state-admin/>
      </div>
    }
  </app-admin-card-with-title>
</ng-container>
